/* MONTKUSH native storefront prompts. No third-party runtime or customer-facing API. */
(function () {
  'use strict';

  var root = document.getElementById('mk-native-prompts');
  var configNode = document.getElementById('mk-native-prompts-config');
  if (!root || !configNode) return;

  var config;
  try {
    config = JSON.parse(configNode.textContent || '{}');
  } catch (_error) {
    return;
  }

  var pagePath = root.getAttribute('data-page-path') || window.location.pathname || '/';
  var productHandle = root.getAttribute('data-product-handle') || '';
  var cartImage = root.getAttribute('data-cart-image') || '';
  var quizImage = root.getAttribute('data-quiz-image') || '';
  var activePrompt = null;
  var intentEvaluated = false;
  var sessionPrefix = 'mkNativePrompt:';

  function safely(storage, operation, key, value) {
    try {
      if (operation === 'get') return storage.getItem(key);
      if (operation === 'set') storage.setItem(key, value);
      if (operation === 'remove') storage.removeItem(key);
    } catch (_error) {
      return null;
    }
    return null;
  }

  function sessionGet(key) { return safely(window.sessionStorage, 'get', sessionPrefix + key); }
  function sessionSet(key, value) { safely(window.sessionStorage, 'set', sessionPrefix + key, value); }
  function localGet(key) { return safely(window.localStorage, 'get', sessionPrefix + key); }
  function localSet(key, value) { safely(window.localStorage, 'set', sessionPrefix + key, value); }


  var promptAnalyticsEndpoint = root.getAttribute('data-mk-prompt-analytics-endpoint') || '';
  var promptIds = { quiz: 'exit_quiz', cart: 'cart_recovery', age: 'age_gate' };

  function analyticsAllowed() {
    try {
      return Boolean(window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' && window.Shopify.customerPrivacy.analyticsProcessingAllowed());
    } catch (_error) {
      return false;
    }
  }

  function newOpaqueId(prefix) {
    var random = '';
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      random = window.crypto.randomUUID().replace(/-/g, '');
    } else {
      random = String(Math.random()).slice(2) + String(Date.now());
    }
    return prefix + '_' + Date.now().toString(36) + random;
  }

  function analyticsSessionId() {
    var key = 'analyticsSession';
    var existing = sessionGet(key);
    if (existing) return existing;
    var created = newOpaqueId('pse');
    sessionSet(key, created);
    return created;
  }

  function promptTouchId(type) {
    var key = 'analyticsTouch:' + type;
    var existing = sessionGet(key);
    if (existing) return existing;
    var created = newOpaqueId('ptc');
    sessionSet(key, created);
    return created;
  }

  function promptDeviceType() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    if (width && width <= 749) return 'mobile';
    if (width && width <= 1024) return 'tablet';
    return 'desktop';
  }

  function sendPromptEvent(type, eventType, touchId) {
    if (!analyticsAllowed() || !promptAnalyticsEndpoint || !promptIds[type]) return Promise.resolve(false);
    var payload = {
      eventId: newOpaqueId('pev'),
      promptId: promptIds[type],
      eventType: eventType,
      sessionId: analyticsSessionId(),
      touchId: touchId || undefined,
      pagePath: pagePath || '/',
      deviceType: promptDeviceType()
    };
    return window.fetch(promptAnalyticsEndpoint, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      keepalive: true,
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(payload)
    }).then(function () { return true; }).catch(function () { return false; });
  }

  function persistPromptAttribution(token) {
    if (!analyticsAllowed() || !token) return Promise.resolve(false);
    var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    if (shopRoot.charAt(shopRoot.length - 1) !== '/') shopRoot += '/';
    return window.fetch(shopRoot + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { '__mk_prompt_attribution': token } })
    }).then(function (response) { return response.ok; }).catch(function () { return false; });
  }

  function trackPrompt(type, eventType) {
    return sendPromptEvent(type, eventType);
  }

  function trackMarketingPromptAction(type, eventType) {
    if (!analyticsAllowed()) return null;
    var token = promptTouchId(type);
    sendPromptEvent(type, eventType, token);
    return persistPromptAttribution(token);
  }

  function handleMarketingPromptCta(event, link, type) {
    var saved = trackMarketingPromptAction(type, 'prompt_cta_click');
    var plainClick = event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && (!link.target || link.target === '_self');
    if (!saved || !plainClick || event.defaultPrevented) return;
    event.preventDefault();
    var href = link.href;
    Promise.race([
      saved,
      new Promise(function (resolve) { window.setTimeout(resolve, 350); })
    ]).then(function () { window.location.assign(href); });
  }

  function toInteger(value, fallback) {
    var parsed = Number(value);
    return Number.isInteger(parsed) ? parsed : fallback;
  }

  function isInternalPath(value) {
    return typeof value === 'string' && value.indexOf('/') === 0 && value.indexOf('//') !== 0;
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof text === 'string') node.textContent = text;
    return node;
  }

  function getPageViews() {
    var current = toInteger(sessionGet('pageViews'), 0) + 1;
    sessionSet('pageViews', String(current));
    return current;
  }

  var pageViews = getPageViews();

  function isSmallScreen() {
    return window.matchMedia && (window.matchMedia('(max-width: 749px)').matches || window.matchMedia('(pointer: coarse)').matches);
  }

  function eligiblePathForIntent() {
    return !/^\/(?:account|challenge|checkouts?)(?:\/|$)/i.test(pagePath) && !/^\/pages\/find-my-formula(?:\/|$)/i.test(pagePath);
  }

  function displayCount(type) {
    return toInteger(localGet('displayCount:' + type), 0);
  }

  function canShow(type, maxDisplays) {
    if (activePrompt || sessionGet('shown:' + type)) return false;
    return displayCount(type) < toInteger(maxDisplays, 1);
  }

  function markShown(type) {
    sessionSet('shown:' + type, '1');
    localSet('displayCount:' + type, String(displayCount(type) + 1));
  }

  function discountLink(code, redirect) {
    if (!/^[A-Za-z0-9_-]{1,64}$/.test(String(code || '')) || !isInternalPath(redirect)) return '';
    return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
  }

  function copyText(value) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(value);
    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      }
      textarea.remove();
    });
  }

  function makeButton(label, className) {
    var button = element('button', className, label);
    button.type = 'button';
    return button;
  }

  function trapFocus(event, wrapper) {
    if (event.key !== 'Tab') return;
    var focusable = wrapper.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function showPrompt(type, details) {
    if (activePrompt) return false;
    var isAge = type === 'age';
    var isCart = type === 'cart';
    var origin = document.activeElement;
    var backdrop = element('div', 'mk-native-prompt-backdrop');
    var dialog = element('section', 'mk-native-prompt mk-native-prompt--' + type);
    var content = element('div', 'mk-native-prompt__content');
    var title = element('h2', 'mk-native-prompt__title', details.heading || 'MONTKUSH');
    var titleId = 'mk-native-prompt-title-' + Date.now();
    title.id = titleId;
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', titleId);

    if (!isAge) {
      var close = makeButton('×', 'mk-native-prompt__close');
      close.setAttribute('aria-label', 'Close this offer');
      close.addEventListener('click', function () { closePrompt('dismissed'); });
      dialog.appendChild(close);
    }

    if (details.eyebrow) content.appendChild(element('p', 'mk-native-prompt__eyebrow', details.eyebrow));
    content.appendChild(title);
    content.appendChild(element('p', 'mk-native-prompt__body', details.body || ''));

    if (isCart && details.couponCode) {
      var coupon = makeButton('', 'mk-native-prompt__coupon');
      coupon.setAttribute('aria-label', 'Copy discount code ' + details.couponCode);
      var couponLabel = element('span', 'mk-native-prompt__coupon-label', details.couponLabel || 'Copy code');
      var couponCode = element('strong', 'mk-native-prompt__coupon-code', details.couponCode);
      coupon.appendChild(couponLabel);
      coupon.appendChild(couponCode);
      coupon.addEventListener('click', function () {
        copyText(details.couponCode).then(function () {
          couponLabel.textContent = 'Copied';
          trackMarketingPromptAction(type, 'prompt_coupon_copy');
          window.setTimeout(function () { couponLabel.textContent = details.couponLabel || 'Copy code'; }, 1800);
        }, function () {
          couponLabel.textContent = 'Copy failed';
          window.setTimeout(function () { couponLabel.textContent = details.couponLabel || 'Copy code'; }, 1800);
        });
      });
      content.appendChild(coupon);
    }

    var actions = element('div', 'mk-native-prompt__actions');
    if (isAge) {
      var decline = document.createElement('a');
      decline.className = 'mk-native-prompt__button mk-native-prompt__button--secondary';
      decline.href = isInternalPath(details.declineUrl) ? details.declineUrl : '/';
      decline.textContent = details.declineLabel || 'No, take me home';
      decline.addEventListener('click', function () { trackPrompt(type, 'prompt_age_decline'); });
      actions.appendChild(decline);
      var accept = makeButton(details.acceptLabel || 'Yes, I’m 21+', 'mk-native-prompt__button');
      accept.addEventListener('click', function () {
        trackPrompt(type, 'prompt_age_accept');
        var days = Math.max(1, Math.min(365, toInteger(details.rememberDays, 30)));
        localSet('ageAcknowledgement:' + productHandle, String(Date.now() + days * 86400000));
        closePrompt('accepted');
      });
      actions.appendChild(accept);
    } else {
      var cta = document.createElement('a');
      cta.className = 'mk-native-prompt__button';
      cta.href = isCart ? (discountLink(details.couponCode, details.ctaUrl || '/cart') || '/cart') : (isInternalPath(details.ctaUrl) ? details.ctaUrl : '/');
      cta.textContent = details.ctaLabel || (isCart ? 'Apply offer' : 'Take the quiz');
      cta.addEventListener('click', function (event) { handleMarketingPromptCta(event, cta, type); });
      actions.appendChild(cta);
    }
    content.appendChild(actions);

    if (!isAge) {
      var imageUrl = isCart ? cartImage : quizImage;
      if (imageUrl) {
        var media = element('div', 'mk-native-prompt__media');
        var image = document.createElement('img');
        image.alt = '';
        image.decoding = 'async';
        image.src = imageUrl;
        media.appendChild(image);
        dialog.appendChild(media);
      }
    }
    dialog.appendChild(content);
    backdrop.appendChild(dialog);
    root.appendChild(backdrop);
    document.documentElement.classList.add('mk-native-prompt-open');
    markShown(type);

    var keydown = function (event) {
      if (event.key === 'Escape' && !isAge) {
        event.preventDefault();
        closePrompt('dismissed');
        return;
      }
      trapFocus(event, dialog);
    };
    document.addEventListener('keydown', keydown);
    if (!isAge) {
      backdrop.addEventListener('click', function (event) {
        if (event.target === backdrop) closePrompt('dismissed');
      });
    }

    activePrompt = {
      type: type,
      close: function (reason) {
        if (reason === 'dismissed') trackPrompt(type, 'prompt_dismiss');
        document.removeEventListener('keydown', keydown);
        backdrop.remove();
        document.documentElement.classList.remove('mk-native-prompt-open');
        activePrompt = null;
        if (origin && typeof origin.focus === 'function') origin.focus();
      },
    };

    var recordImpression = function () {
      if (document.documentElement.contains(backdrop)) trackPrompt(type, 'prompt_view');
    };
    if (window.requestAnimationFrame) window.requestAnimationFrame(recordImpression);
    else window.setTimeout(recordImpression, 0);

    window.setTimeout(function () {
      var primary = dialog.querySelector('.mk-native-prompt__close, .mk-native-prompt__button');
      if (primary) primary.focus();
    }, 0);
    return true;
  }

  function closePrompt(reason) {
    if (activePrompt) activePrompt.close(reason);
  }

  function ageAcknowledged() {
    var until = toInteger(localGet('ageAcknowledgement:' + productHandle), 0);
    return until > Date.now();
  }

  function showAgeGateIfNeeded() {
    var age = config.ageGate || {};
    var productHandles = Array.isArray(age.productHandles) ? age.productHandles : [];
    if (!age.enabled || !productHandle || productHandles.indexOf(productHandle) === -1 || ageAcknowledged()) return false;
    return showPrompt('age', age);
  }

  function cartEligible() {
    var cart = config.cartRecovery || {};
    if (!cart.enabled || !eligiblePathForIntent() || !canShow('cart', cart.maxDisplaysPerVisitor)) return Promise.resolve(false);
    return window.fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        return Boolean(data && data.item_count > 0 && Number(data.total_price || 0) >= toInteger(cart.minCartCents, 0));
      })
      .catch(function () { return false; });
  }

  function quizEligible() {
    var quiz = config.exitQuiz || {};
    var minimumPages = isSmallScreen() ? toInteger(quiz.mobileMinPages, 3) : toInteger(quiz.desktopMinPages, 4);
    return Boolean(quiz.enabled && eligiblePathForIntent() && pageViews >= minimumPages && canShow('quiz', quiz.maxDisplaysPerVisitor));
  }

  function evaluateIntent() {
    if (intentEvaluated || activePrompt) return;
    intentEvaluated = true;
    cartEligible().then(function (hasCart) {
      if (hasCart) {
        showPrompt('cart', config.cartRecovery || {});
      } else if (quizEligible()) {
        showPrompt('quiz', config.exitQuiz || {});
      }
    });
  }

  function bindDesktopIntent() {
    document.addEventListener('mouseout', function (event) {
      if (event.relatedTarget || event.clientY > 0) return;
      evaluateIntent();
    });
  }

  function bindMobileIntent() {
    var idleTimer;
    var timeout = Math.max(
      toInteger((config.exitQuiz || {}).mobileIdleSeconds, 20),
      toInteger((config.cartRecovery || {}).mobileIdleSeconds, 20)
    ) * 1000;
    function resetIdle() {
      window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(evaluateIntent, timeout);
    }
    ['pointerdown', 'touchstart', 'scroll', 'keydown'].forEach(function (eventName) {
      window.addEventListener(eventName, resetIdle, { passive: true });
    });
    resetIdle();
  }

  function begin() {
    if (showAgeGateIfNeeded()) return;
    if (!eligiblePathForIntent()) return;
    if (isSmallScreen()) bindMobileIntent();
    else bindDesktopIntent();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', begin, { once: true });
  else begin();
}());

